<h2 mat-dialog-title><b>Session Timeout Warning</b></h2>
    <mat-dialog-content>Your session will expire in 5 minutes due to inactivity.  Please choose to stay signed in or to log off.</mat-dialog-content>
    <mat-dialog-actions>
        <button mat-button mat-dialog-close=true (click)="closeDialog()">Stay Logged In</button>
        <button mat-button mat-dialog-close=false>Log Off</button>
    </mat-dialog-actions>
